import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Chinese%20national%20brands%20exhibition%20panorama%20with%20warm%20golden%20and%20red%20atmosphere%2C%20grand%20modern%20exhibition%20center%2C%20professional%20wide%20angle%20photography%2C%20bright%20clean%20lighting&width=1920&height=600&seq=cta-bg-gcdyy-02&orientation=landscape"
          alt="品牌入驻背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          让世界看到你的品牌
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-lg mx-auto leading-relaxed">
          国产第一页面向全国优秀自主品牌开放入驻，让更多消费者发现并爱上你的产品。
          加入我们，一起助力国货崛起！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            立即入驻
          </Link>
          <Link
            to="/category/keji-shuma"
            className="px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-md hover:bg-background-50/20 border border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            浏览更多品牌
          </Link>
        </div>
      </div>
    </section>
  );
}